import { createSelector } from '@reduxjs/toolkit'
import * as con from '../../GlobalConstants'

const selectHistoricDollarInfo = (state) => state[con.REDUCER_MARKET_VALUES][con.HISTORIC_DOLLAR_INFO]

const findClosestBelow = (dates, values, referenceDate) => {
    if (!dates || !values || !referenceDate) return null
    
    const refTime = new Date(referenceDate).getTime()
    let closestIndex = -1

    for (let i = 0; i < dates.length; i++) {
        const d = new Date(dates[i]).getTime()
        if (d <= refTime) closestIndex = i
        else break
    }

    return closestIndex >= 0 ? values[closestIndex] : null
}

const findClosestAbove = (dates, values, referenceDate) => {
    if (!dates || !values || !referenceDate) return null
    
    const refTime = new Date(referenceDate).getTime()

    for (let i = 0; i < dates.length; i++) {
        const d = new Date(dates[i]).getTime()
        if (d > refTime) return values[i]
    }

    return null
}

export const makeSelectTRMForDate = (referenceDate) => createSelector(
    [selectHistoricDollarInfo],
    (historic) => {
        if (!historic) return null
        return findClosestBelow(historic[con.DATES], historic[con.TRM], referenceDate)
    }
)

export const makeSelectTRM1ForDate = (referenceDate) => createSelector(
    [selectHistoricDollarInfo],
    (historic) => {
        if (!historic) return null
        return findClosestAbove(historic[con.DATES], historic[con.TRM], referenceDate)
    }
)

export const makeSelectCloseForDate = (referenceDate) => createSelector(
    [selectHistoricDollarInfo],
    (historic) => {
        if (!historic) return null
        return findClosestBelow(historic[con.DATES], historic[con.CLOSE], referenceDate)
    }
)